export default {
  methods: {
    isRead (id) {
      return this.$store.state.documentsRead.indexOf(id) !== -1
    }
  },
}
